import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'decimalFormat'
})
export class DecimalFormatPipe implements PipeTransform {
  transform(value: any): string {
    if (value === null || value === undefined || value === '') {
      return '0.00';
    }
    
    const numValue = Number(value);
    if (isNaN(numValue)) {
      return '0.00';
    }
    
    // Format with 2 decimal places and add commas as thousands separators
    return numValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
}
